<div class="p-5 border border-gray-200 rounded-2xl dark:border-gray-800 lg:p-6">
  <div class="flex flex-col gap-6 lg:flex-row lg:items-start lg:justify-between">
    <div>
      <h4 class="text-lg font-semibold text-gray-800 dark:text-white/90 lg:mb-6">
        Personal Information
      </h4>
      <div class="grid grid-cols-1 gap-4 lg:grid-cols-2 lg:gap-7 2xl:gap-x-32">
        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            First Name
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            {{ user.firstName }}
          </p>
        </div>
        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            Last Name
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            {{ user.lastName }}
          </p>
        </div>
        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            Email address
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            {{ user.email }}
          </p>
        </div>
        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            Phone
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            {{ user.phone }}
          </p>
        </div>
        <div>
          <p class="mb-2 text-xs leading-normal text-gray-500 dark:text-gray-400">
            Bio
          </p>
          <p class="text-sm font-medium text-gray-800 dark:text-white/90">
            {{ user.bio }}
          </p>
        </div>
      </div>
    </div>
    <button
      (click)="openModal()"
      class="flex w-full items-center justify-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-3 text-sm font-medium text-gray-700 shadow-theme-xs hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200 lg:inline-flex lg:w-auto"
    >
      <svg
        class="fill-current"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.0911 2.78206C14.2125 1.90338 12.7878 1.90338 11.9092 2.78206L4.57524 10.116C4.26682 10.4244 4.0547 10.8158 3.96468 11.2426L3.31231 14.3352C3.25997 14.5833 3.33653 14.841 3.51583 15.0203C3.69512 15.1996 3.95286 15.2761 4.20096 15.2238L7.29355 14.5714C7.72031 14.4814 8.11172 14.2693 8.42013 13.9609L15.7541 6.62695C16.6327 5.74827 16.6327 4.32365 15.7541 3.44497L15.0911 2.78206ZM12.9698 3.84272C13.2627 3.54982 13.7376 3.54982 14.0305 3.84272L14.6934 4.50563C14.9863 4.79852 14.9863 5.2734 14.6934 5.56629L14.044 6.21573L12.3204 4.49215L12.9698 3.84272ZM11.2597 5.55281L5.6359 11.1766C5.53309 11.2794 5.46238 11.4099 5.43238 11.5522L5.01758 13.5185L6.98394 13.1037C7.1262 13.0737 7.25666 13.003 7.35947 12.9002L12.9833 7.27639L11.2597 5.55281Z"
          fill=""
        />
      </svg>
      Edit
    </button>
  </div>

  <!-- Modal -->
  <app-modal
    [isOpen]="isOpen"
    (close)="closeModal()"
    className="max-w-[700px] m-4"
  >
    <div class="no-scrollbar relative w-full max-w-[700px] overflow-y-auto rounded-3xl bg-white p-4 dark:bg-gray-900 lg:p-11">
      <div class="px-2 pr-14">
        <h4 class="mb-2 text-2xl font-semibold text-gray-800 dark:text-white/90">
          Edit Personal Information
        </h4>
        <p class="mb-6 text-sm text-gray-500 dark:text-gray-400 lg:mb-7">
          Update your details to keep your profile up-to-date.
        </p>
      </div>
      <form class="flex flex-col" (ngSubmit)="handleSave()">
        <div class="custom-scrollbar h-[450px] overflow-y-auto px-2 pb-3">
          <div>
            <h5 class="mb-5 text-lg font-medium text-gray-800 dark:text-white/90 lg:mb-6">
              Social Links
            </h5>
            <div class="grid grid-cols-1 gap-x-6 gap-y-5 lg:grid-cols-2">
              <div>
                <app-label>Facebook</app-label>
                <app-input-field type="text" [value]="user.social.facebook" />
              </div>
              <div>
                <app-label>X.com</app-label>
                <app-input-field type="text" [value]="user.social.x" />
              </div>
              <div>
                <app-label>Linkedin</app-label>
                <app-input-field type="text" [value]="user.social.linkedin" />
              </div>
              <div>
                <app-label>Instagram</app-label>
                <app-input-field type="text" [value]="user.social.instagram" />
              </div>
            </div>
          </div>
          <div class="mt-7">
            <h5 class="mb-5 text-lg font-medium text-gray-800 dark:text-white/90 lg:mb-6">
              Personal Information
            </h5>
            <div class="grid grid-cols-1 gap-x-6 gap-y-5 lg:grid-cols-2">
              <div class="col-span-2 lg:col-span-1">
                <app-label>First Name</app-label>
                <app-input-field type="text" [value]="user.firstName" />
              </div>
              <div class="col-span-2 lg:col-span-1">
                <app-label>Last Name</app-label>
                <app-input-field type="text" [value]="user.lastName" />
              </div>
              <div class="col-span-2 lg:col-span-1">
                <app-label>Email Address</app-label>
                <app-input-field type="text" [value]="user.email" />
              </div>
              <div class="col-span-2 lg:col-span-1">
                <app-label>Phone</app-label>
                <app-input-field type="text" [value]="user.phone" />
              </div>
              <div class="col-span-2">
                <app-label>Bio</app-label>
                <app-input-field type="text" [value]="user.bio" />
              </div>
            </div>
          </div>
        </div>
        <div class="flex items-center gap-3 px-2 mt-6 lg:justify-end">
          <app-button size="sm" variant="outline" (btnClick)="closeModal()">Close</app-button>
          <app-button size="sm" (btnClick)="handleSave()">Save Changes</app-button>
        </div>
      </form>
    </div>
  </app-modal>
</div>